import NavbarGlobal from 'Components/UI/Molecules/NavBar'
import TableIngress from 'Components/UI/Organisms/Plant/Stock/TableIngress'
import Template from 'Components/UI/Templates/Common'

const Ingress = () => {
  return (
    <Template
      navbar={<NavbarGlobal title="Planta" subTitle="Movimiento de stock" subTitle2="INGRESO" />}
      table={<TableIngress />}
    />
  )
}
export default Ingress
